import dynamic from 'next/dynamic';
import React from 'react';

import {ClientSideRender} from '@udemy/design-system-utils';
import {Loader} from '@udemy/react-reveal-components';

import styles from './client-side-video-player.module.less';

import type {VideoPlayerClientProps} from './video-player-client.react-component';

const UI_REGION = 'client-side-video-player';

export type ClientSideVideoPlayerProps = VideoPlayerClientProps;

const DynamicClientSideVideoPlayer = dynamic(
    () => import('./video-player-client.react-component').then((m) => m.VideoPlayerClient),
    {ssr: false, loading: () => <VideoPlayerLoader />},
);

export const VideoPlayerLoader = () => (
    <div className={styles.container}>
        <Loader className={styles.loader} overlay size="xlarge" />
    </div>
);

export const ClientSideRenderWrapper = ({children}: {children: React.ReactNode}) => (
    <ClientSideRender placeholder={<VideoPlayerLoader />} uiRegion={UI_REGION}>
        {children}
    </ClientSideRender>
);

export const ClientSideVideoPlayer = (props: ClientSideVideoPlayerProps) => (
    <ClientSideRenderWrapper>
        <DynamicClientSideVideoPlayer {...props} />
    </ClientSideRenderWrapper>
);
